<script lang="ts">
    import StepperBox from "../components/StepperBox.svelte";
    import {_} from '../services/i18n';

    export let uniqueID: string;

    declare var lang: string;

    let animate;

    function copied() {
        animate = true;
        /*
            const copyDiv = document.querySelector('.copyAlert:not(.animate)');
            if(copyDiv) {
                copyDiv.classList.add('animate');
                //copyDiv.addEventListener('animationend', () => copyDiv.classList.remove('animate') );
            }
        */
        setTimeout(async () => {
            animate = false
        }, 4000)
    }
</script>


<StepperBox title="Reporting illegal content" stepText="Finish!">
    <h1 class="main-heading">{$_('stepComplete.title')}</h1>

    <div class="personal-code-section">
        <h2>{$_('stepComplete.uuidLabel')}</h2>
        <div class="code">{uniqueID}</div>
        <button type="button" class="btn-copy"
                on:click={() => {navigator.clipboard.writeText(uniqueID); copied()}}>{$_('stepComplete.copyBtn')}</button>
        <span class:animate="{animate}" class="copyAlert">{$_('stepComplete.copiedLabel')}</span>

    </div>
    {#if lang == 'en'}
        <div class="info-text">
            <p>
                Thank you for having taken civic action against illegal content online.
                Your report was registered with the following identification number: {uniqueID}
            </p>
            <p>Your report will be investigated by the operators of the BEE SECURE Stopline.</p>
            <p>
                Vous pouvez utiliser ce numéro d'identification pour suivre le statut de votre déclaration
                dans notre chaîne de traitement et obtenir un éventuel retour d'information individuel. Veuillez trouver toutes les informations pertinentes sur les rapports sur la page :
                <a href="http://stopline.bee-secure.lu/#reportprocess" target="_blank">Comment signaler ?</a>.
            </p>
        </div>
    {/if}
    {#if lang == 'de'}
        <div class="info-text">
            <p>
                Vielen Dank, dass Sie gegen illegale Online-Inhalte vorgegangen sind.
                Ihre Meldung wurde unter der folgenden Identifikationsnummer registriert: {uniqueID}
            </p>
            <p>Ihre Meldung wird von den Betreibern der BEE SECURE Stopline geprüft.</p>
            <p>
                Mit dieser Identifikationsnummer können Sie den Status Ihrer Meldung in unserer Bearbeitungskette verfolgen und
                eine eventuelle individuelle Rückmeldung zu erhalten. Alle relevanten Informationen zur Meldung finden Sie auf der Seite
                <a href="https://stopline.bee-secure.lu/de#reportprocess" target="_blank">Meldevorgang</a>.
            </p>
        </div>
    {/if}
    {#if lang == 'fr'}
        <div class="info-text">
            <p>
                Nous vous remercions d'avoir pris des mesures civiques contre les contenus illégaux en ligne.
                Votre rapport a été enregistré avec le numéro d'identification suivant : {uniqueID}
            </p>
            <p>Votre rapport sera examiné par les opérateurs de la Stopline BEE SECURE.</p>
            <p>
                You can use this identification number to track the status of your report in our processing chain and
                get possible individual feedback. Please find all relevant information about reporting on the page
                <a href="https://stopline.bee-secure.lu/fr/#reportprocess" target="_blank">How to report?</a>.
            </p>
        </div>
    {/if}

    <div class="bottom-buttons">
        <button class="btn-bottom" on:click={() => window.location.reload()}>{$_('stepComplete.reportMoreBtn')}</button>
        <a class="btn-bottom" href="/#status">{$_('stepComplete.checkStatusBtn')}</a>
    </div>
</StepperBox>
<!--<Step let:nextStep num={4}>-->
<!--</Step>-->

<style lang="scss">
  .main-heading {
    font-family: 'Open Sans', sans-serif;
    font-size: 40px;
    font-weight: 800;
    line-height: 54px;
    letter-spacing: 0;
    text-align: left;

    margin-bottom: 80px;
  }

  /* 600px, 900px, 1200px, and 1800px */
  @media (max-width: 900px) {
    .main-heading {
      font-size: 30px;
      line-height: 40px;
    }
  }

  h2 {
    display: inline;
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
    line-height: 36px;

    margin: auto 35px auto 0;

    color: #000000;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  div.code {
    display: inline;
    border: 1px solid #C8C8C8;
    border-radius: 12px;
    background: white;

    padding: 5px 25px;

    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
    line-height: 36px;

    margin-right: 10px;
    margin-top: 5px;

    color: #DE1125;

    word-break: break-word;
  }

  button.btn-copy {
    all: unset;

    padding: 10px 25px;

    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    /*line-height: 22px;*/
    color: black;

    cursor: pointer;
    border: 1px solid #C8C8C8;
    border-radius: 12px !important;

    margin-top: 5px;
  }

  button.btn-copy:hover {

    background: #DE1125;
    color: #fff;
  }

  .copyAlert {

    margin-left: 10px;
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;

  }

  .animate {
    animation: disappear 4s linear;
  }

  .copyAlert {
    opacity: 0;
  }

  @keyframes disappear {
    0% {
      opacity: 0;
    }
    30% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }


  .info-text {
    margin-top: 20px;
    width: 50%;
  }

  /* 600px, 900px, 1200px, and 1800px */
  @media (max-width: 900px) {
    .info-text {
      width: 100%;
    }
  }

  .bottom-buttons {
    margin-top: 75px;
  }

  .btn-bottom {
    all: unset;
    cursor: pointer;

    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 33px;
    color: #000000;

    background: #C8C8C8;
    border-radius: 12px !important;

    padding: 12px 16px;

    margin-top: 5px;
    margin-right: 20px;
    width: max-content;
  }
</style>
